import React from "react";
import { Route, Redirect } from "react-router-dom";
import config from "../../config";

export default function PublicRoute({
  component: Component,
  restricted,
  // user,
  ...rest
}) {
  const user = JSON.parse(localStorage.getItem(config.keys.user));
  const isLoginPath = rest.path === config.routes.login;

  return (
    <Route
      {...rest}
      exact
      render={(props) =>
        // Always show login page at "/" so the root URL opens login
        isLoginPath ? (
          <Component {...props} user={user} />
        ) : user && user.id && restricted ? (
          <Redirect to={config.routes.dashboard} />
        ) : (
          <Component {...props} user={user} />
        )
      }
    />
  );
}
